import { useEffect, useRef } from "react";
import { Tooltip } from "antd";
import moment from "moment";
import "./GeogridHistoryBar.css";

export const GeogridHistoryBar = (props: {
    history: any[];
    currentGrid: number;
    onSelect: (grid: any, index: number) => void;
}) => {
    const items = (props.history || []).slice(0, 20);
    const scrollRef = useRef<HTMLDivElement>(null);
    const selectedRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const timer = window.setTimeout(() => {
            selectedRef.current?.scrollIntoView({
                inline: 'nearest',
                block: 'nearest',
                behavior: 'smooth',
            });
        }, 50);
        return () => window.clearTimeout(timer);
    }, [props.currentGrid, items.length]);

    return (
        <div style={{
            margin: '4px 10px 0',
            background: '#F4F7FA',
            paddingBottom: 0,
        }}>
            <div style={{
                padding: '4px 10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: 10,
            }}>
                <span style={{
                    flexShrink: 0,
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#64748b',
                    whiteSpace: 'nowrap',
                }}>
                    Histórico
                </span>

                <div
                    ref={scrollRef}
                    className="geogrid-history-scroll"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: 6,
                        overflowX: 'auto',
                        flex: 1,
                        minWidth: 0,
                        paddingBottom: 1,
                    }}
                >
                    {items.map((grid: any, index: number) => {
                        const selected = index === props.currentGrid;
                        const date = moment.utc(grid.created).local();
                        const radiusParts = grid.radiusParts;
                        const radius = grid.radius;
                        const gridSide = radius != null ? Number(radius) * 2 : null;
                        const gridLabel = gridSide != null ? `Grid ${gridSide} x ${gridSide} mts²` : null;

                        const button = (
                            <button
                                type="button"
                                ref={selected ? selectedRef : undefined}
                                onClick={() => props.onSelect(grid, index)}
                                style={{
                                    flex: '0 0 auto',
                                    display: 'inline-flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    gap: selected ? 5 : 3,
                                    padding: selected ? '9px 15px' : '6px 12px',
                                    borderRadius: 8,
                                    border: selected ? '1.5px solid var(--blue-tag)' : '1px solid #e2e8f0',
                                    background: selected ? 'rgba(27, 110, 245, 0.08)' : '#fff',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'left',
                                    transition: 'padding 0.15s ease, background 0.15s ease',
                                    minWidth: selected ? 180 : undefined,
                                }}
                            >
                                <span style={{
                                    fontSize: selected ? 13 : 12,
                                    fontWeight: selected ? 700 : 500,
                                    color: selected ? 'var(--blue-tag)' : '#475569',
                                    letterSpacing: '0.01em',
                                }}>
                                    {date.format('D MMM YY · HH:mm')}
                                </span>

                                {gridLabel && (
                                    selected ? (
                                        <span style={{
                                            display: 'inline-flex',
                                            alignItems: 'baseline',
                                            gap: 4,
                                            marginTop: 2,
                                            padding: '4px 10px',
                                            borderRadius: 6,
                                            background: '#fff',
                                            border: '1px solid #e2e8f0',
                                            boxShadow: '0 1px 2px rgba(34, 50, 93, 0.04)',
                                        }}>
                                            <span style={{
                                                fontSize: 12,
                                                fontWeight: 700,
                                                color: 'var(--blue-tag)',
                                                lineHeight: 1.2,
                                            }}>
                                                {gridLabel}
                                            </span>
                                        </span>
                                    ) : (
                                        <span style={{
                                            fontSize: 10,
                                            color: '#94a3b8',
                                            fontWeight: 400,
                                            lineHeight: 1.3,
                                        }}>
                                            {gridLabel}
                                        </span>
                                    )
                                )}
                            </button>
                        );

                        if (selected) return <span key={grid.id || index}>{button}</span>;

                        return (
                            <Tooltip
                                key={grid.id || index}
                                title={
                                    <>
                                        <div>{date.format('LLLL')}</div>
                                        <div><b>{date.fromNow()}</b></div>
                                        {gridLabel && <div>{gridLabel}</div>}
                                        {radiusParts != null && (
                                            <div>{radiusParts * 2 + 1}x{radiusParts * 2 + 1} puntos</div>
                                        )}
                                    </>
                                }
                            >
                                {button}
                            </Tooltip>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
